import { Home } from "../../../routes";
import { Anchor } from "../Anchor";
import style from "./MobileHeader.module.scss";
import cx from "classnames";
import { useContext, useRef, useState } from "react";
import { ColorContext } from "../../../ColorContext";
import React from "react";
import { About, ProperCare, ToBuy, Videos } from "../../../AnchorContext";

const Logo = ({ hide }: { hide?: boolean }) => {
  return (
    <div
      className={cx({
        [style.noLogo]: hide,
      })}
    >
      <Home.Link>
        <div className={style.logo}>
          <img src="/logo-main.svg" alt="logo" />
        </div>
      </Home.Link>
    </div>
  );
};

const Burger = ({
  onClick,
  onBlur,
}: {
  onClick: () => void;
  onBlur?: () => void;
}) => {
  return (
    <div className={style.burger}>
      <button
        className={style.btn__closeOpen}
        onClick={onClick}
        onBlur={onBlur}
      >
        <div></div>
      </button>
    </div>
  );
};

export const MobileHeader = () => {
  const isHome = Home.useIsCurrentRoute();
  const [folded, setFolded] = useState(true);
  const { color } = useContext(ColorContext);

  return (
    <>
      <header
        className={cx(style.header, {
          [style.foldedMenu]: folded,
        })}
        style={{ backgroundColor: color }}
      >
        <div className={style.mobileMenuTop}>
          <Logo />
          <Burger
            onClick={() => {
              setFolded(!folded);
            }}
            //   onBlur={() => {
            //       setFolded(true)
            //   }}
          />
        </div>
        <div className={cx(style.mobileMenu)}>
          <nav
            className={cx(style.nav)}
            onClick={() => {
              setFolded(true);
            }}
          >
            <ul>
              <About.Link>
                <li>О проекте</li>
              </About.Link>
              <ProperCare.Link>
                <li>Правильный уход</li>
              </ProperCare.Link>
              <Videos.Link thisPage>
                <li>Видео</li>
              </Videos.Link >
              {/* <ToBuy.Link>
                <li>Средства ухода</li>
              </ToBuy.Link> */}
            </ul>
          </nav>
        </div>
      </header>
    </>
  );
};
